import { AfterViewInit, Directive, ElementRef, OnDestroy, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { PcpResizeObserver, ResizedEvent } from '@pcp/core/util';


@Directive({ selector: '[pcpResized]' })
export class ResizedDirective implements AfterViewInit, OnDestroy {
    @Output("pcpResized") resized$: Observable<ResizedEvent>;
    private resizeObserver: PcpResizeObserver;

    constructor(
        private element: ElementRef<Element>,
    ) {
        this.resizeObserver = new PcpResizeObserver();
        this.resized$ = this.resizeObserver.resized$;
    }

    ngAfterViewInit(): void {
        this.resizeObserver.observe(this.element.nativeElement);
    }

    ngOnDestroy(): void {
        this.resizeObserver.unobserve(this.element.nativeElement);
    }
}
